import { YMInitializer } from '@appigram/react-yandex-metrika';

interface YandexMetricaProps {
  accounts: number[];
}

export const YandexMetrica = (props: YandexMetricaProps) => {
  if (import.meta.env.DEV) {
    return null;
  }

  return (
    <YMInitializer
      accounts={props.accounts}
      options={{
        clickmap: true,
        trackLinks: true,
        accurateTrackBounce: true,
        webvisor: true,
        trackHash: true,
      }}
      version="2"
    />
  );
};
